import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Notification from "../../elements/notification/Notification";
import RetryCallbackButton from "../../elements/retryCallbackButton/RetryCallbackButton";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { useHistory } from "react-router-dom";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PaymentDetailsContent from "./PaymentDetailsContent";
import { AppContext } from "../../../App";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledPaymentDetailsWrapper } from "../styledPayment";
import { HTTP_STATUSES, PAYMENT_SYSTEM, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";

const PaymentDetailsContainer = ({ match }) => {
  const { t } = useTranslation("transactionDetailsPage");
  const history = useHistory();
  let [payment, setPayment] = useState(null);

  const [transferUserEmail, setTransferUserEmail] = useState(null);

  const { user } = useContext(AppContext);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchPayment = async () => {
    let responsePayment = null;

    await axios.get("/api/payments/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setPayment(response.data);

        responsePayment = response.data;
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });

    return responsePayment;
  };

  const fetchTransferDetails = (responsePayment) => {

    if(!responsePayment || responsePayment.paymentSystem.subName !== PAYMENT_SYSTEM.BALANCE_TRANSFER) {
      return;
    }

    axios.get(`/api/transfers?payment.referenceId=${responsePayment.referenceId}`, userAuthenticationConfig()).then(response => {
      if(response.status === HTTP_STATUSES.HTTP_OK && response.data['hydra:member'][0]) {
        setTransferUserEmail(response.data['hydra:member'][0]?.payout?.connection?.project?.user?.email);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }


  const fetchPaymentTransactionOrPaymentTransfer = () => {
    fetchPayment().then(responsePayment => {
      fetchTransferDetails(responsePayment);
    });
  }

  // TODO Add pusher
  useEffect(() => {
    fetchPaymentTransactionOrPaymentTransfer();
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.paymentTitle")}</title>
        </Helmet>
        <StyledPaymentDetailsWrapper>
          <div className="payment-details-head">
            <GoToBackButton
              handler={() => {history.goBack();}}
            />
            <RetryCallbackButton
              id={match.params.id}
              type="payments"
              setNotification={setNotification}
              notification={notification}
            />
          </div>
          <PaymentDetailsContent payment={payment} transferUserEmail={transferUserEmail}/>
        </StyledPaymentDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default PaymentDetailsContainer;